import React, {useEffect, useRef, useState} from "react"
import styled from "styled-components"
import _ from "lodash"

import automationService from "data/automation"
import BasicModal from "components/modal/basic-modal"


const NewPropFormContainer = styled.div`
  input {
    width: 60px;
  }
  button {
    margin-left: 20px;
  }
`

type Mover = (kind: 'up'|'down'|'to', value: number) => void

type MoveRowModalProps = {
  close: Function
  move: Mover
  rowNum: number
  show: boolean
}

const MoveRowModal = (props: MoveRowModalProps) => {
  const buttonRef = useRef<any>()
  const inputRef = useRef<any>()
  const [inputFocused, setInputFocused] = useState(false)

  useEffect(() => {
    if (!props.show) {
      setInputFocused(false)
      inputRef.current.value = ''
      automationService.broadcast("MODAL_CLOSING", {})
    }
    else if (!inputFocused && inputRef.current) {
      inputRef.current.focus()
      setInputFocused(true)
    }

  }, [props.show])

  const getDestination = () => parseInt(_.get(inputRef,'current.value'))


  const keyDown = (e) => {
    if (e.key == 'Tab') {
      e.preventDefault()
      e.stopPropagation()
      // toggle focus
      if (e.target === buttonRef.current) inputRef.current.focus()
      else buttonRef.current.focus()
    } else if (e.key == 'Enter') {
      props.move('to', getDestination())
    } else if (e.key == 'ArrowUp') {
      inputRef.current.value = +inputRef.current.value + 1
    } else if (e.key == 'ArrowDown') {
      inputRef.current.value = Math.max(1, +inputRef.current.value - 1)
    }
  }

  const move = () => {
    props.move('to', getDestination())
  }

  return (
    <BasicModal
      width={225}
      show={props.show}
      toggleShow={() => { props.close() }}
      title={"Move Row #" + props.rowNum}>
        <NewPropFormContainer>
          To Row <input onKeyDown={keyDown} ref={inputRef}></input>
          <button onKeyDown={keyDown} ref={buttonRef} onClick={move}>Move</button>
        </NewPropFormContainer>
    </BasicModal>
  )
}

export default MoveRowModal
